
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, allowedRoles }) => {
  const isLoggedIn = localStorage.getItem("login") === "true";
  const userRole = localStorage.getItem("role"); // e.g. "User" | "OWNER" | "Subscriber"

  // 👇 Get permissions from localStorage
  const storedPermissions = localStorage.getItem("permissions");
  const permissions: string[] = storedPermissions ? JSON.parse(storedPermissions) : [];

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  //console.log("permissions:::"+permissions);
  //console.log("allowedRoles:::"+allowedRoles);

  //console.log("Status::"+(allowedRoles.some(role => permissions.includes(role))))

  if(allowedRoles.some(role => permissions.includes(role))) {
    return element;
  } else if (!allowedRoles.some(role => permissions.includes(role))) {
    // 🚫 redirect to forbidden page instead of unauthorized
    return <Navigate to="/forbidden" replace />;
  }

  
};

export default ProtectedRoute;